<div class="flex min-h-screen w-full items-start justify-center px-4 py-24 bg-center bg-no-repeat bg-cover relative"
     style="background-image: url('../../../assets/images/login-bg.jpg');">
  <div class="absolute inset-0 bg-black/15 backdrop-blur-sm -z-0"></div>

  <div class="w-full max-w-lg bg-white rounded-2xl shadow-xl p-12 relative">
    <div class="flex flex-col items-center">
      <img class="w-44 h-44 rounded-full bg-white p-2 absolute left-1/2 -translate-x-1/2 -top-20"
           src="../../../assets/images/logo-small.svg" alt="Login">

      <div class="flex flex-col items-center mx-auto mt-14">
        <!-- PIN Input -->
        <div class="col-span-3 flex justify-center items-center mb-6">
          <p-inputotp
            [(ngModel)]="pin"
            [integerOnly]="true"
            [mask]="!showPassword"
            [length]="6"
            (onChange)="pinChanged()"
            styleClass="w-full max-w-xs text-center text-2xl tracking-widest w-16 h-16"
          />

          <span (click)="onShowPswClear()"
                class="ml-2 text-gray-400 hover:text-gray-600 cursor-pointer text-xl"
                [class]="showPassword ? 'pi pi-eye' : 'pi pi-eye-slash'">
          </span>
        </div>
        <div class="grid grid-cols-3 gap-3 w-fit">
          <!-- Number buttons 1-9 -->
          <ng-container *ngFor="let num of [1,2,3,4,5,6,7,8,9]">
            <p-button
              styleClass="flex items-center justify-center w-21 h-21 rounded-full bg-primary-500 text-white text-3xl font-bold hover:brightness-110 active:translate-y-px transition"
              (click)="fieldPress(num)"
              label="{{num}}"
            />
          </ng-container>

          <!-- Empty cell, 0, Clear -->
          <div></div>
          <p-button
            styleClass="flex items-center justify-center w-21 h-21 rounded-full bg-primary-500 text-white text-3xl font-bold hover:brightness-110 active:translate-y-px transition"
            (click)="fieldPress(0)"
            [label]="'0'"
          />
          <p-button
            styleClass="flex items-center justify-center w-21 h-21 rounded-full bg-primary-500 text-white text-4xl font-bold hover:brightness-110 active:translate-y-px transition"
            (click)="fieldPress('clear')"
            icon="pi pi-replay"
          />
        </div>
      </div>
    </div>
  </div>
</div>
